import { useTypedParams } from '@sorare/routing';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

import { MyCardsRevealableCardsTypeSearchPage } from '@sorare/gameplay/src/pages/MyCardsRevealableCardsTypeSearchPage';

import { PageParams } from './__generated__/routeParams';

const FootballMyCardsRevealableCardsTypeSearchPage = () => {
  const { type } = useTypedParams<PageParams>();
  return <MyCardsRevealableCardsTypeSearchPage type={type as Rarity} />;
};

export default FootballMyCardsRevealableCardsTypeSearchPage;
